import confetti from 'canvas-confetti'
/**
 * Trigger a subtle confetti effect from a specific element
 */
export const triggerSubtleConfetti = (element: HTMLElement | null) => {
  if (!element) return
  const rect = element.getBoundingClientRect()
  const x = (rect.left + rect.width / 2) / window.innerWidth
  const y = (rect.top + rect.height / 2) / window.innerHeight
  confetti({
    particleCount: 30,
    spread: 70,
    origin: { x, y },
    colors: ['#BADFDB', '#FFA4A4', '#FFBDBD'],
    disableForReducedMotion: true,
    scalar: 0.7,
  })
}
/**
 * Trigger a celebration confetti effect from the center of the screen
 */
export const triggerCelebrationConfetti = () => {
  const duration = 1500
  const end = Date.now() + duration
  const colors = ['#BADFDB', '#FFA4A4', '#FFBDBD', '#FCF9EA']
  ;(function frame() {
    confetti({
      particleCount: 2,
      angle: 60,
      spread: 55,
      origin: { x: 0 },
      colors,
    })
    confetti({
      particleCount: 2,
      angle: 120,
      spread: 55,
      origin: { x: 1 },
      colors,
    })
    if (Date.now() < end) {
      requestAnimationFrame(frame)
    }
  })()
}
